export default __webpack_public_path__ + "static/media/22.8862639b.svg";